<template>
	<div>
<!--    <login-after-head ref="loginAfterHead"></login-after-head>-->

<!--    <head-nav-bar></head-nav-bar>-->
    <i-head-top></i-head-top>
<!--    <div style="height: 500px">-->
<!--&lt;!&ndash;      <image src="https://zxapi.tengen.com.cn/appStatic/kefu.jpg" style="width: 500px;height: 1200px" ></image>&ndash;&gt;-->


<!--    </div>-->
    <div style="text-align: center;margin-top: 10px">
      <img src="https://zxapi.tengen.com.cn/appStatic/kefu.jpg" width="380px"/>
    </div>
    <div class='imagesize' style="margin-top: -100px;">
      <br/>
      红包将于添加成功后1-3个工作日内发放
    </div>
    <div class='imagesize' style="font-size: 14px;margin-top: 70px;">
      ⚠️ 注意：添加时必须备注好营业执照公司名称
    </div>

    <div class='imagesize' style="font-size: 14px;">
      法人姓名及手机号码，才能审核通过发放红包！
    </div>


		<i-footer></i-footer>

	</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		mounted() {
		},
		methods: {
		}
	}
</script>

<style>

.kefu-banner {
  width: 100%;
  height: 650px;
  min-width: 1200px;
  min-height: 650px;
  background: url(https://zxapi.tengen.com.cn/appStatic/kefu.jpg) center no-repeat;
}

.imagesize {
  display: flex;
  justify-content: center;
}

image {
  width: 1050 px;
  height: 1200 px;
}
</style>
